<template>
 <div id="order">
  <dd-header></dd-header>
  <!-- 上部タブ -->
  <nav id="main_nav">
   <ul class="container">
    <li class=" choosing_tab main_tab">
      <h2>受注リスト</h2>
    </li>
   </ul>
  </nav>
  <div class="container_main">
    <!--  メインコンテンツ  -->
    <main>
      <div class="order_header">
        <button class="main_btn search_btn" @click="onSearch()">絞り込み条件選択</button>
        <button @click="downLoadCsv" class="main_btn search_btn" v-if="totalCount > 0">CSV出力</button>
        <!-- ページ -->
        <div class="pager">
          <dd-pager
            v-if="tableModel.columnDataList && tableModel.columnDataList.length > 0"
              :pageNo="pageNo"
              :dataCountPerPage="dataCount"
              :totalDataCount="totalCount"
              :columnDataList="tableModel.columnDataList"
              @downLoadCsv="downLoadCsv"
              @paging="paging"
            />
          <div class="disp_btn" @click="onDisp()">
            <div class="disp_icon">
              <span class="displogo"></span>
              <span class="displogo"></span>
              <span class="displogo"></span>
            </div>
            <div class="disptitle">表示項目</div>
          </div>
        </div>
        <div class="right_space"></div>
        <!-- <button class="main_btn search_btn" @click="onDisp()">表示条件</button> -->
      </div>
      <dd-table
        :columnList="columnList"
        :dataList="dataList"
        :totalCount="totalCount"
        :pageNo="pageNo"
        :dataCount="dataCount"
        @confirm="confirm"
        v-if="totalCount > 0"
      />
      <div class="zerodata" v-else>
        検索条件に一致するデータが見つかりませんでした。
      </div>
    </main>
  </div>
  <dd-footer />
  <!-- ローディングモーダル -->
  <dd-loading-modal ref="loadingModalRef" />
 </div>
</template>
<script>
// Libraries
import axios from 'axios'
// Module
import moment from 'moment'
import encoding from 'encoding-japanese'
import {API_URL, DC_STORAGE_KEY} from '../constants/App'
import * as Api from '../utils/Api'
import * as App from '../utils/App'
import Header from '../components/common/Header'
import Footer from '../components/common/Footer'
import OrderTable from '../components/order/OrderTable'
import Pager from '../components/common/OrderPager'
import LoadingModal from '../components/common/LoadingModal'

export default {
  name: 'Order',
  components: {
    'dd-header': Header,
    'dd-footer': Footer,
    'dd-table': OrderTable,
    'dd-pager': Pager,
    'dd-loading-modal': LoadingModal
  },
  data () {
    return {
      /** テーブルデータ */
      tableModel: {},
      /** ページ番号 */
      pageNo: this.$route.params.pageNo == null ? 1 : this.$route.params.pageNo,
      /** 1ページごとの表示件数 */
      dataCount: this.$route.params.dataCount == null ? 16 : this.$route.params.dataCount,
      /** 総件数 */
      totalCount: 0,
      orderCode: '',
      searchForm: {
        odMgCode: '',
        orderCode: '',
        planId: '',
        status: [],
        status3: undefined,
        updateUserName: '',
        orderDateStart: '',
        orderDateEnd: '',
        corpName: '',
        userName: '',
        paymentDateLimitType: '',
        paymentDateLimitStart: '',
        paymentDateLimitEnd: '',
        paymentType: [],
        paymentDateType: '',
        paymentDateStart: '',
        paymentDateEnd: '',
        priceStart: '',
        priceEnd: '',
        priceTaxStart: '',
        priceTaxEnd: '',
        seriesName: '',
        productName: '',
        sizeWStart: '',
        sizeWEnd: '',
        sizeHStart: '',
        sizeHEnd: '',
        sizeDStart: '',
        sizeDEnd: '',
        sizeW2Start: '',
        sizeW2End: '',
        sizeH2Start: '',
        sizeH2End: '',
        sizeD2Start: '',
        sizeD2End: '',
        doorColor: '',
        cabineColor: '',
        counterColor: '',
        isConstruct: '',
        isCarry: '',
        makerName: '',
        businessName: '',
        deliveryName: '',
        receiverName: '',
        receiverTel: '',
        deliveryAddress: '',
        infoDeliveryDateStart: '',
        infoDeliveryDateEnd: '',
        deliveryDateStart: '',
        deliveryDateEnd: '',
        platformDateStart: '',
        platformDateEnd: '',
        userDateStart: '',
        userDateEnd: '',
        constructDateStart: '',
        constructDateEnd: '',
        productUnitCount: '',
        attendName: '',
        attendTel: '',
        constructAddress: '',
        isHomeType: '',
        isParking: '',
        branch: '',
        userTel: '',
        media: [],
        inviteCode: '',
        researchDeliName: '',
        researchName: '',
        researchTel: '',
        researchDateStart: '',
        researchDateEnd: '',
        isDayAttend: ''
      },
      dispForm: {
        checkList: []
      },
      defaultDispForm: [
        0, 1, 3, 5, 6, 9, 10, 11, 12, 22, 23, 24, 25, 41, 42
      ]
    }
  },
  computed: {
    columnList: function () {
      if (!this.dispForm) return this.tableModel.columnList
      let _this = this
      return this.tableModel.columnList.filter(function (c, index) {
        return _this.dispForm.checkList.indexOf(index) >= 0
      })
    },
    dataList: function () {
      if (!this.dispForm) return this.tableModel.columnDataList
      let _this = this
      let row = this.tableModel.columnDataList.map(function (data, index) {
        let param = data.filter(function (d, index) {
          return _this.dispForm.checkList.indexOf(index) >= 0
        })
        return param
      })
      return row
    }
  },
  methods: {
    /** ページング処理 */
    getTableInfoAndAllData: function (searchForm) {
      // let payload = {
      //   pageNo: searchForm.pageNo,
      //   dataCount: searchForm.dataCount
      // }
      axios.post(API_URL.ORDER + '/list', searchForm)
        .then(response => {
          this.tableModel = response.data.data
          this.totalCount = response.data.data.totalCount
          this.dataCount = response.data.data.dispNum
          // this.pageNo = param1
          // this.dataCount = param2
          // this.getTableRows(this.tableModel.tableName)
        }).catch(error => {
          Api.handleError(error)
        })
    },
    downLoadCsv: function () {
      this.$refs.loadingModalRef.showModal(true)
      axios.get(API_URL.ORDER + '/download')
        .then(response => {
          let formatStr = moment().format('YYYYMMDDHHmmss')
          let columnHeaders = response.data.data.columnList
          let arrayData = response.data.data.columnDataList
          // ヘッダー行をデータの先頭に追加
          let headerRow = columnHeaders.map(header => header.columnName)
          arrayData.unshift(headerRow)

          let csvData = arrayData.map(function (l) { return l.join(',') }).join('\r\n')
          // SJISに変換する
          let sjisArray = encoding.convert(encoding.stringToCode(csvData), {to: 'SJIS'})
          let blob = new Blob([new Uint8Array(sjisArray)], { type: 'text/csv' })
          let link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = 'OrderList_' + formatStr + '.csv'
          link.click()
          let modalData = {
            messages: ['ファイルをダウンロードしました。']
          }
          App.showModal(modalData)
          this.$refs.loadingModalRef.showModal(false)
        }).catch(error => {
          this.$refs.loadingModalRef.showModal(false)
          Api.handleError(error, this.errorMessage, this.validateErrorMessages)
        })
    },
    // 数字ボタンが押すたびに動く処理
    paging: function (pageNo) {
      this.pageNo = pageNo
      this.searchForm.pageNo = pageNo
      this.searchForm.dataCount = this.dataCount
      this.getTableInfoAndAllData(this.searchForm)
    },
    onSearch: function () {
      this.pageNo = 1
      let modalData = {
        callbackParams: {},
        onSearch: (callback) => {
          let searchForm = callback.searchForm
          searchForm.pageNo = this.pageNo
          searchForm.dataCount = this.dataCount
          this.searchForm = searchForm
          App.setLocalStorage(DC_STORAGE_KEY.ORDER_SEARCH, this.searchForm)
          this.getTableInfoAndAllData(this.searchForm)
        },
        refSearchForm: this.searchForm
      }
      App.showOrderSearchModal(modalData)
    },
    onDisp: function () {
      let modalData = {
        callbackParams: {},
        onDisp: (callback) => {
          this.dispForm = Object.assign({}, callback.dispForm)
          // this.dispForm = callback.dispForm
          App.setLocalStorage(DC_STORAGE_KEY.ORDER_DISP, this.dispForm)
          // this.getTableInfoAndAllData(this.dispForm)
        },
        refDispForm: this.dispForm,
        defaultDispForm: this.defaultDispForm
      }
      App.showOrderDispModal(modalData)
    },
    confirm: function (colData) {
      this.$set(this.tableModel, 'pageNo', this.pageNo)
      App.setLocalStorage(DC_STORAGE_KEY.ORDER_LIST_DATA, this.tableModel)
      this.$router.push({
        name: 'OrderDetail',
        query: {id: colData}
      })
    }
  },
  created: function () {
    let searchForm = App.getLocalStorage(DC_STORAGE_KEY.ORDER_SEARCH)
    if (Object.keys(searchForm).length > 0) {
      // 検索条件復元
      this.searchForm = Object.assign({}, searchForm)
      this.searchForm.pageNo = this.pageNo
      this.searchForm.dataCount = this.dataCount
    }
    let tableData = App.getLocalStorage(DC_STORAGE_KEY.ORDER_LIST_DATA)
    if (tableData && Object.keys(tableData).length > 0) {
      // 詳細画面から戻った時の情報復元
      App.removeLocalStorage(DC_STORAGE_KEY.ORDER_LIST_DATA)
      history.pushState(null, null, null)
      this.tableModel = tableData
      this.totalCount = tableData.totalCount
      this.dataCount = tableData.dispNum
      this.pageNo = tableData.pageNo
    } else {
      // データの取得
      if (Object.keys(searchForm).length > 0) {
        this.getTableInfoAndAllData(this.searchForm)
      } else {
        // 検索条件なし
        searchForm = {
          pageNo: this.pageNo,
          dataCount: this.dataCount
        }
        this.getTableInfoAndAllData(searchForm)
      }
    }
    // 表示制御
    let dispForm = App.getLocalStorage(DC_STORAGE_KEY.ORDER_DISP)
    if (Object.keys(dispForm).length > 0) {
      this.dispForm = Object.assign({}, dispForm)
    } else {
      this.dispForm = {
        checkList: this.defaultDispForm
      }
    }
  }
}
</script>
<style src="../css/order/order.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/pages/OrderList.vue